"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dialogs_1 = require("../dialogs");
/**Devuelve true si cierto objeto es una excepción amistosa */
function isFriendlyError(x) {
    return typeof x == "object" && x.friendly === true && (typeof (x.message) == "string");
}
exports.isFriendlyError = isFriendlyError;
/**Ejecuta una función y muestra un mensaje de error si la exepcion que devuelve es una amistosa. Devuelve true si no hubo error */
async function execUserFunc(func) {
    if (func == null)
        return true;
    try {
        await func();
        return true;
    }
    catch (error) {
        //Si el error cumple con la especificacion de error amistoso, mostramos el error al usuario
        if (isFriendlyError(error)) {
            await dialogs_1.message("", error.message, "error");
        }
        else {
            console.error(error);
        }
        return false;
    }
}
exports.execUserFunc = execUserFunc;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/botones/exec.js
// module id = 166
// module chunks = 0